var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelopeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 15.9402C22 18.7302 19.76 20.9902 16.97 21.0002H16.96H7.05C4.27 21.0002 2 18.7502 2 15.9602V15.9502C2 15.9502 2.006 11.5242 2.014 9.2982C2.015 8.8802 2.495 8.6462 2.822 8.9062C5.198 10.7912 9.447 14.2282 9.5 14.2732C10.21 14.8422 11.11 15.1632 12.03 15.1632C12.95 15.1632 13.85 14.8422 14.56 14.2622C14.613 14.2272 18.767 10.8932 21.179 8.9772C21.507 8.7162 21.989 8.9502 21.99 9.3672C22 11.5762 22 15.9402 22 15.9402Z",
    fill: "#41D5E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4759 5.6736C20.6099 4.0416 18.9059 2.9996 17.0299 2.9996H7.04988C5.17388 2.9996 3.46988 4.0416 2.60388 5.6736C2.40988 6.0386 2.50188 6.4936 2.82488 6.7516L10.2499 12.6906C10.7699 13.1106 11.3999 13.3196 12.0299 13.3196C12.0339 13.3196 12.0369 13.3196 12.0399 13.3196C12.0429 13.3196 12.0469 13.3196 12.0499 13.3196C12.6799 13.3196 13.3099 13.1106 13.8299 12.6906L21.2549 6.7516C21.5779 6.4936 21.6699 6.0386 21.4759 5.6736Z",
    fill: "#41D5E2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelopeIcon.8138b886c39a5f789c0371441abc0c74.svg";
export { ForwardRef as ReactComponent };